// Material UI
import { Typography } from '@mui/material';

// Utility
import { capitalizeWord } from 'utility/strings';


export function SeatLabel(props) {
    const { section, row, seat, category, channel } = props.seat;

    const seatLabelValues = [];

    if (section.label) {
        section.type
            ? seatLabelValues.push(`${capitalizeWord(section.type)} ${section.label}`)
            : seatLabelValues.push(section.label);
    }
    if (row.label) {
        row.type
            ? seatLabelValues.push(`${capitalizeWord(row.type)} ${row.label}`)
            : seatLabelValues.push(row.label);
    }
    if (seat.label) {
        if (seat.type === 'ga') {
            seatLabelValues.push(seat.label);
        } else {
            seat.type
                ? seatLabelValues.push(`${capitalizeWord(seat.type)} ${seat.label}`)
                : seatLabelValues.push(seat.label);
        }
    }

    const seatLabel = seatLabelValues.length ? seatLabelValues.join(' • ') : '';
    const channelLabel = channel?.label;

    return (
        <>
            <Typography variant='inherit'>{category.label || ''}</Typography>
            <Typography variant='caption'>
                {seatLabel}
                {channelLabel ? (seatLabel ? ' • ' : '') : ''}
                {channelLabel ? (
                    <Typography component='span' variant='caption' sx={{ color: 'info.main', fontWeight: 700 }}>
                        {channelLabel}
                    </Typography>
                ) : null}
            </Typography>
        </>
    )
}
